








































import { Component, Prop } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm } from '@/components/bwaff';

@Component({
  components: {
    DialogForm,
  }
})
export default class TwoFactorBackupCodeDialog extends Form {
  @Prop({ default: {} })
  data: any;

  close() {
    const { onClose } = this.data

    this.$emit('close');
    onClose && onClose()
  }
}
